import styled from 'styled-components'
import bg from '../../assets/login/bg4.jpg';
export const LoginStyle = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  .login{
    width: 600px;
    height: 400px;
    background: rgba(221, 238, 241, .3);
    margin: 0 auto;
    margin-top: 12%;
    box-sizing: border-box;
    padding-top: 60px;
    box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.23);
    p{
      width: 20%;
      margin: 0 auto;
      margin-bottom: 50px;
      img{
        width: 100%;
      }
    }
  }
`